import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { API_URL, API_URL_V4 } from 'src/environments/environment.local';

@Injectable()
export class UatInterceptor implements HttpInterceptor {
  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    // Add authorization header with uat if available
    if (
      localStorage.getItem('user_access_token') &&
      (request.url.includes(API_URL) || request.url.includes(API_URL_V4))
    ) {
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${localStorage.getItem('user_access_token')}`,
        },
      });
    }

    return next.handle(request);
  }
}
